import { createSwrListStore } from './swr/createSwrListStore';
import { getLibraryCharacters } from '../lib/api';

const swr = createSwrListStore({
  name: 'LibraryCharactersStore',
  storageKey: 'bookthing-library-characters',
  cacheVersion: 2,
  itemsField: 'characters',
  setters: {
    set: 'setCharacters',
    add: 'addCharacter',
    update: 'updateCharacter',
    remove: 'removeCharacter',
    reset: 'resetLibraryCharacters',
  },
  fetcher: async () => {
    const resp = await getLibraryCharacters();
    return resp.characters || [];
  },
});

export const useLibraryCharactersStore = swr.useStore;
export const useLibraryCharactersData = swr.useData;
export const fetchLibraryCharactersIfStale = swr.fetchIfStale;
